import { defineStore } from 'pinia';
import axiosInstance from '@/axios';
import urlList from '../../utils/apis.json';

export const useTransfersStore = defineStore('transfers', {
    state: () => ({
        dataList: null,
        dataTransfer: null
    }),

    actions: {
        getList(payload = null) {
            // store.showLoading(true);
            axiosInstance.defaults.headers.common['Authorization'] =
                `Bearer ${window.localStorage.getItem('token')}` || '';
            return axiosInstance
                .get(urlList['transfers'],{ ...payload })
                .then((res) => {
                    // @ts-ignore
                    this.dataList = res;
                    return res;
                }).finally(() => {

                });
        },
        async getDetail(id) {
            try {
                await axiosInstance.get(`${urlList['transfers']}/${id}`).then((res) => {
                    this.dataTransfer = res.data;
                    return res;
                });
            } catch (error) {
                console.error('Error :', error);
                throw error;
            }
        },
        async add(formData) {
            try {
                return axiosInstance.post(urlList['transfers'], formData).then((res) => {
                    return res;
                });
            } catch (error) {
                console.error('Error :', error);
                throw error;
            }
        },
        async update(formData, id) {
            try {
                return axiosInstance.put(`${urlList['transfers']}/${id}`, formData).then((res) => {
                    return res;
                });
            } catch (error) {
                console.error('Error :', error);
                throw error;
            }
        },
        async delete(id) {
            try {
                return await axiosInstance.delete(`${urlList['transfers']}/${id}`);
            } catch (error) {
                console.error('Error:', error);
                throw error;
            }
        }
    },
    getters: {}
});
